import { render, staticRenderFns } from "./properties-block-word-page.vue?vue&type=template&id=05455893&scoped=true"
import script from "./properties-block-word-page.vue?vue&type=script&lang=js"
export * from "./properties-block-word-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05455893",
  null
  
)

export default component.exports